type Callback = () => void

let didComplete = false
let callbacks: Callback[] = []

const rewindListener = (jwPlayer: jwplayer.JWPlayer, onRewind: Callback) => {
  callbacks.push(onRewind)

  jwPlayer.on('complete', () => {
    didComplete = true
  })

  jwPlayer.on('play', () => {
    if (didComplete) {
      didComplete = false
      callbacks.forEach(cb => cb())
    }
  })

  jwPlayer.on('remove', () => {
    callbacks = []
  })
}

export default rewindListener
